export default __webpack_public_path__ + "static/media/virtual-reality.434809ae.svg";